// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import ProductPrice from '../../../../ProductDetail/molecules/ProductPrice/ProductPrice';
import LoaderSkelton from '../../../../../../common/molecules/LoaderSkelton';

export const StyledPriceContainer = styled(ProductPrice)`
  .actual-price {
    ${(props) => {
      return (
        props.isBundlePageRedesign &&
        ` @media ${props.theme.mediaQuery.smallOnly} {
          margin-top: 0;
          font-size: ${props.theme.fonts.fontSize.body.bodytext.copy4}px;
          padding-top: ${props.theme.spacing.ELEM_SPACING.XXS};
        }
        font-size: ${props.theme.fonts.fontSize.body.bodytext.copy6}px;
        padding-top: ${props.theme.spacing.ELEM_SPACING.XXS};
     `
      );
    }};
  }
`;
export const StyledLoaderSkeleton = styled(LoaderSkelton)`
  &.switch-skeleton {
    margin-top: 16px;
    height: 42.5px;
    float: right;
    width: 100px;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-right: 13px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin-right: 15px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-right: 14px;
    }
  }
`;

export const StyledPaginatedGridSkeleton = styled.div`
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    height: 385px;
    padding-top: 24px;
  }

  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    height: 386px;
    padding-top: 24px;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    height: 509px;
    padding-top: 31px;
  }
  .grid-image-skeleton {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 210px;
    }

    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 210px;
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      height: 300px;
    }
    margin-bottom: 12px;
  }
  .grid-price-skeleton {
    display: flex;
    justify-content: space-between;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: 24px;
      height: 48px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      margin-top: 20px;
      height: 35px;
    }
  }
  .grid-promo-skeleton {
    margin-top: 10px;
    height: 25px;
  }
  .grid-title-skeleton {
    margin-top: 4px;
    height: 35px;
  }
`;
export default css`
  background: ${(props) => props.theme.colors.WHITE};
  .plp-grid {
    display: grid;
    width: 100%;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 15px;
    grid-row-gap: 24px;
    padding-top: 24px;
    border-bottom: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
    padding-bottom: 7px;

    @media ${(props) => props.theme.mediaQuery.small} {
      grid-template-columns: repeat(auto-fill, minmax(163px, 1fr));
    }

    @media ${(props) => props.theme.mediaQuery.medium} {
      grid-column-gap: 32px;
      padding-top: 32px;
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      grid-column-gap: 16px;
      grid-row-gap: 64px;
      grid-template-columns: repeat(auto-fill, minmax(264px, 1fr));
      padding-bottom: 19px;
    }
  }
  .bundle-product-grid-container {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 0;
      width: 100%;
    }
  }
  .breadcrumb-container {
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      margin-top: 16px;
    }
  }
  .breadcrum-wrapper {
    margin: 0 0 16px;

    @media ${(props) => props.theme.mediaQuery.medium} {
      margin: 0 0 ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) =>
        props.isBundlePageRedesign
          ? `margin: 0 0 ${props.theme.spacing.ELEM_SPACING.LRG};`
          : `margin: 0 0 ${props.theme.spacing.ELEM_SPACING.XXL};`}
    }
  }

  .product-detail-skeleton-wrapper {
    display: flex;
    flex-direction: row;
    .main-image-container-wrap {
      margin: 0;
      width: 100%;
    }
  }
  .thumbnail-list {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    height: 110px;
  }
  .product-main-image {
    height: 436px;
    width: 100%;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
    margin-right: 0;
  }
  .product-overview-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-left: 0;
  }
  .bundle-product-grid-skeleton {
    margin: 0;
    width: 100%;
  }
  .main-bundle-description {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      overflow: hidden;
      margin-left: 14px;
      margin-right: 14px;
    }
  }
  .product-price-container {
    ${(props) =>
      props.isBundlePageRedesign &&
      `padding-bottom: ${props.theme.spacing.ELEM_SPACING.LRG};
    @media ${props.theme.mediaQuery.smallOnly}{
      border-bottom: 0;
      padding-bottom: 0;
    }
    `};
  }
  .plcc-wrapper {
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      height: 47px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 66px;
    }
  }
  .price-container.quick-view-drawer-redesign {
    align-items: flex-start;
  }
  .price-container {
    ${(props) => props.isBundlePageRedesign && `display: flex`};
  }
  .list-badge-container {
    ${(props) =>
      props.isBundlePageRedesign && ` margin-left: ${props.theme.spacing.ELEM_SPACING.XS_1};`};
  }
  .original-price {
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    @media ${(props) => props.theme.mediaQuery.medium} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    }
  }
  .product-title {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy6}px;
    height: ${(props) => props.theme.spacing.ELEM_SPACING.MED_2};
    padding-bottom: 8px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: auto;
      width: 90%;
      margin: 0;
      padding-bottom: 4px;
    }
  }
  .product-summary-wrapper-new-design {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: space-between;
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  }
  .title-wrapper-new-design {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy6}px;
    line-height: 27px;
  }
  .product-price-col {
    padding-bottom: 24px;
    border-bottom: 1px solid ${(props) => props.theme.colors.DIVIDER};
    margin-bottom: 24px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-top: ${({ theme }) => theme.spacing.ELEM_SPACING.LRG};
    }
  }
  .bundle-social-wrapper-redesign {
    justify-content: right;
  }
  .icon-pinterest {
    ${(props) =>
      props.isBundlePageRedesign &&
      `@media ${props.theme.mediaQuery.mediumMax} {
     margin-right: ${props.theme.spacing.ELEM_SPACING.REG};
    }`};
  }
  .icon-facebook .facebook,
  .icon-pinterest .pinterest,
  .icon-twitter .twitter {
    ${(props) => {
      return (
        props.isBundlePageRedesign &&
        `
      height: ${props.theme.spacing.ELEM_SPACING.LRCX};
      width: ${props.theme.spacing.ELEM_SPACING.LRCX};

      @media ${props.theme.mediaQuery.mediumMax} {
        height:${props.theme.spacing.APP_LAYOUT_SPACING.XS};
        width:${props.theme.spacing.APP_LAYOUT_SPACING.XS};
      }`
      );
    }};
  }
  .product-skeleton-description {
    height: 90px;
  }
  .combined-kit-skeleton {
    display: flex;
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .loader-skeleton-kit {
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 107px;
      width: 85px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      height: 86px;
      width: 70px;
    }
    margin-right: 12px;
  }
  .combined-kits-wrapper-skeleton {
    margin-top: ${({ theme }) => theme.spacing.ELEM_SPACING.LRG};
  }
  .product-price {
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding-bottom: 24px;
      height: 35px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 30px;
      padding-bottom: 10px;
    }
    width: 70%;
  }
  .product-color {
    width: 100%;
    height: 70px;
    margin-bottom: ${(props) => props.theme.spacing.APP_LAYOUT_SPACING.XS};
  }
  .product-size {
    width: 100%;
    height: 70px;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
  }
  .product-add-to-bag {
    width: 100%;
    height: 50px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: 0 ${(props) => props.theme.spacing.ELEM_SPACING.REG};
      width: 90%;
    }
  }
  .product-image {
    margin-right: ${(props) => props.theme.spacing.APP_LAYOUT_SPACING.XS};
    margin-bottom: ${(props) => props.theme.spacing.APP_LAYOUT_SPACING.XS};
    height: 50px;
  }
  .outfit-carousal-skeleton-image {
    ${(props) =>
      props.isCombinedKitsEnabled
        ? `
    overflow: hidden;
    width: 384px;
    @media ${props.theme.mediaQuery.mediumOnly} {
      width: 372px;
    }`
        : `
    @media ${props.theme.mediaQuery.medium} {
      width: 267px;
    }
    `}
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    .main-bundle-description {
      flex-grow: 1;
    }
    .product-detail-skeleton-wrapper {
      display: flex;
      flex-direction: row;
    }
    .product-main-image {
      height: 703px;
      flex: 1;
      margin-right: 5%;
    }
    .product-overview-wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-right: 2%;
    }
    .product-overview-detail-wrapper {
      width: 100%;
      display: flex;
      flex-direction: row;
    }
    .product-image {
      flex: 1;
      display: flex;
      height: 261px;
      margin-right: ${(props) => props.theme.spacing.APP_LAYOUT_SPACING.XS};
    }
    .product-title-price-wrapper {
      flex: 2;
      display: flex;
      flex-direction: column;
    }
  }
  @media only screen and (max-width: 1200px) {
    .full-size-desktop-image {
      height: auto;
      padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.REG};
      width: 94%;
    }

    .product-skeleton-img {
      height: 429px;
      width: 93%;
      margin: 0 14px;
    }
  }

  @media only screen and (min-width: 1200px) {
    .full-size-desktop-image {
      width: 691px;
    }
  }
  .main-bundle-image {
    ${(props) =>
      props.isCombinedKitsEnabled
        ? `
    @media ${props.theme.mediaQuery.mediumOnly} {
      width: 372px;
    }
    `
        : `
    @media ${props.theme.mediaQuery.mediumOnly} {
      width: 267px;
    }`}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .product-detail-skeleton-wrapper {
      display: flex;
      flex-direction: row;
    }
    .thumbnail-list-wrapper {
      width: 8%;
      display: flex;
      flex-direction: column;
      margin-right: 5%;
    }
    .product-main-image {
      height: 703px;
      flex: 1;
      margin-right: 5%;
    }
    .product-overview-wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-right: 2%;
    }
    .product-overview-detail-wrapper {
      width: 100%;
      display: flex;
      flex-direction: row;
    }
    .product-image {
      flex: 1;
      display: flex;
      height: 261px;
      margin-right: ${(props) => props.theme.spacing.APP_LAYOUT_SPACING.XS};
    }
    .product-title-price-wrapper {
      flex: 2;
      display: flex;
      flex-direction: column;
    }
    .main-bundle-image {
      ${(props) => {
        if (props.isCombinedKitsEnabled) {
          return `
      height: auto;
      @media ${props.theme.mediaQuery.large} {
        width: 384px !important;
      }`;
        }
        return ` width: 267px;
      height: auto;`;
      }}
      padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    }
    .main-bundle-image.nonretrieved {
      ${({ isCombinedKitsEnabled }) => !isCombinedKitsEnabled && ` height: 334px;`}
    }
    .main-bundle-description {
      flex-grow: 1;
    }
  }

  ${(props) => (props.inheritedStyles ? props.inheritedStyles : '')};
`;
